export default __webpack_public_path__ + "static/FirstsafetyInspirationStoryOne-e064f5118c134ec761b3baa1b0091f4b.webp";